module.exports = __webpack_public_path__ + "img/title_bottom.5aaaa861.png";